/*
**	Utility functions for WFMT dynamic loading
**	by Nate Beversluis
*/


/*
** Parse a URL into its components, returning these as an object.
** (protocol, host, hostname, port, pathname, search string, searchObject, hash)
*/

function parseURL(url) {

    var parser = document.createElement('a'),
	searchObject = {},
	queries, split, i;
	parser.href = url;
	var hash = parser.hash.split('?')[0] || ''
	var query = parser.hash.split('?')[1] || ''
	var pathname = parser.pathname;
	if (pathname.slice(-1) == '/') {
		pathname = pathname.slice(0,-1) 
	}
	if (query) {
		queries = query.split('&');	
		for( i = 0; i < queries.length; i++ ) {
			split = queries[i].split('=');
			searchObject[split[0]] = split[1];
		}
	}
	if ( ! pathname ) { pathname = '/'}
    return {
        protocol: parser.protocol,
        host: parser.host,
        hostname: parser.hostname,
        port: parser.port,
        pathname: pathname,
        search: parser.search,
        searchObject: searchObject,
        hash: hash
    };
}

/*
** Decode text that might contain HTML
** https://stackoverflow.com/questions/7394748/whats-the-right-way-to-decode-a-string-that-has-special-html-entities-in-it?lq=1
*/


function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

/*
** Old way of loading scripts manually, from
** https://humanwhocodes.com/blog/2009/07/28/the-best-way-to-load-external-javascript/
*/

function loadScript(url, callback){

    var script = document.createElement("script")
    script.type = "text/javascript";

    if (script.readyState){  //IE
        script.onreadystatechange = function(){
            if (script.readyState == "loaded" ||
                    script.readyState == "complete"){
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  //Others
        script.onload = function(){
            callback();
        };
    }

    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
}




function getAnchoredElement(anchorID) {	
	// remove the leading hash if there is one 
	if (anchorID.substring(0,1) == '#') { anchorID = anchorID.slice(1) }

	// allow both ID and `name` attribute as anchors
	var destinationElement = jQuery('#'+anchorID);
	if ( destinationElement.length == 0 ) {
		destinationElement= jQuery('*[name="'+anchorID+'"]')
	}

	return destinationElement
}

export { parseURL, decodeHtml, loadScript, getAnchoredElement }
